import { useStyletron } from '@thanx/uikit/theme'
import { ReactComponent as IconCheck } from 'assets/images/icon-check.svg'
import { ReactComponent as IconCross } from 'assets/images/icon-cross.svg'
import palette from 'constants/palette'
import React from 'react'

type Props = {
  suggestion: string
  categoryId: string
  onAccept: () => void
  onReject: () => void
}

const PendingAiSuggestion: React.FC<Props> = ({
  suggestion,
  categoryId,
  onAccept,
  onReject,
}) => {
  const [css] = useStyletron()

  return (
    <div
      data-testid={`pending-ai-${categoryId}`}
      className={css({
        marginTop: '8px',
        backgroundColor: palette.spearmint10,
        borderLeft: '2px solid #13C1BF',
        borderRadius: '4px',
        padding: '10px 12px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
      })}
    >
      <div className={css({ flex: 1 })}>
        <span
          className={css({
            display: 'block',
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '20px',
            color: '#757575',
            marginBottom: '2px',
          })}
        >
          AI Suggestion
        </span>
        <span
          data-testid={`pending-ai-text-${categoryId}`}
          className={css({
            fontSize: '14px',
            color: palette.grey90,
          })}
        >
          {suggestion}
        </span>
      </div>
      <button
        data-testid={`reject-ai-${categoryId}`}
        onClick={onReject}
        aria-label="Reject suggestion"
        className={css({
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '4px',
          lineHeight: 0,
          display: 'flex',
          alignItems: 'center',
        })}
        title="Reject suggestion"
      >
        <IconCross width={20} height={20} />
      </button>
      <button
        data-testid={`accept-ai-${categoryId}`}
        onClick={onAccept}
        aria-label="Accept suggestion"
        className={css({
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '4px',
          lineHeight: 0,
          display: 'flex',
          alignItems: 'center',
        })}
        title="Accept suggestion"
      >
        <IconCheck width={20} height={20} />
      </button>
    </div>
  )
}

export default PendingAiSuggestion
